import React from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import "./FaqAccordionCss";
import FaqAccordionItem from "../FaqAccordionItem/FaqAccordionItem";
import { useAuth } from "modules/auth/hooks";

const FaqAccordion = (props: any) => {
  const data = [
    {
      title: "What is Staidium?",
      description:
        "Staidium is a platform that focuses on innovative and tailored experiences for users across sports genres. Unique features include AI and machine learning content services, league specific content, and integration of advanced technologies to enhance user engagement and satisfaction. Whether it involves specialized programs, unique access, or user-centric tools, Staidium stands out by delivering a seamless and enriched user journey designed to meet the needs of sports leagues and sports enthusiasts."
    },
    {
      title: "How can I sign up for an account?",
      description: `You can create an account by visiting <a href="/signup">Subscribe</a> and following the prompts to register with your details.`

    },
    {
      title: "What are the main benefits of using Staidium?",
      description:
        "Users can enjoy personalized experiences, innovative tools, and features that enhance engagement and the overall OTT streaming experience. Staidium's platform is structured to deliver a user-friendly experience, ensuring seamless streaming (Broadcast quality) interaction and efficient use of its services. Whether it’s through league specific content, exclusive access, or intuitive design, Staidium stands out as a go-to for users seeking a premium, customized offerings."
    },
    {
      title: "What payment options are available?",
      description:
        "We accept <img width='10%' src='/strip_logo_transparent.png' />"
    },
    {
      title: "Is customer support available?",
      description:
        "Yes, customer support is available 24/7"
    }
  ];

  return (
    <div className={"section-pt-90 section-pb-90"} style={{ ...props.style }}>
      <Container>
        <Row style={{ justifyContent: "center" }}>
          <h2
            className="section-title-5"
            style={{
              fontSize: "50px",
              color: "#fff",
              margin: "0 0 35px",
              textAlign: "center",
              display: props?.title ? "inherit" : "none",
              justifyContent: "center"
            }}
          >
            {props?.title}
          </h2>
          <Col lg="9">
            <Accordion id="faqAccordion">
              {data.map((item, index) => {
                return (
                  <FaqAccordionItem
                    key={index}
                    title={item.title}
                    description={item.description}
                    index={index}
                  />
                );
              })}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FaqAccordion;
